<template>
  <div class="goods-keyword-search">
    <el-select
      :value="value.matchField"
      size="small"
      class="goods-search-field"
      :popper-class="dropdownClass"
      aria-label="搜索字段"
      @change="updateField"
    >
      <el-option v-for="field in fields" :key="field.value" :label="field.label" :value="field.value" />
    </el-select>
    <el-input
      ref="keyword"
      :value="value.keyword"
      :placeholder="placeholder"
      size="small"
      clearable
      class="goods-search-keyword"
      aria-label="搜索关键词"
      @input="updateKeyword"
      @clear="$emit('search')"
      @keyup.enter.native="$emit('search')"
    />
  </div>
</template>

<script>
import { GOODS_SEARCH_FIELDS } from './goodsSearch'

export default {
  props: {
    value: { type: Object, required: true },
    dropdownClass: { type: String, default: '' }
  },
  data() {
    return { fields: GOODS_SEARCH_FIELDS }
  },
  computed: {
    placeholder() {
      return (this.fields.find(field => field.value === this.value.matchField) || this.fields[0]).placeholder
    }
  },
  methods: {
    updateField(matchField) {
      this.$emit('input', { ...this.value, matchField })
    },
    updateKeyword(keyword) {
      this.$emit('input', { ...this.value, keyword })
    },
    focus() {
      this.$refs.keyword.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-keyword-search {
  display: flex;
  width: 460px;
  max-width: 100%;
  .goods-search-field {
    flex: 0 0 130px;
    width: 130px;
    ::v-deep .el-input__inner {
      border-radius: 4px 0 0 4px;
      background: #f5f7fa;
    }
  }
  .goods-search-keyword {
    flex: 1;
    min-width: 0;
    ::v-deep .el-input__inner {
      border-radius: 0 4px 4px 0;
      border-left: 0;
    }
  }
}
</style>

<style>
.filterTops4 > .el-form > .goods-keyword-filter { width: 49.62%; }
</style>
